import { db } from '../firebase/config';
import { collection, addDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';

// Fonction pour enregistrer un token FCM pour un utilisateur
export const saveUserToken = async (userId, userType, token) => {
  try {
    // Vérifier si le token existe déjà pour cet utilisateur
    const tokensRef = collection(db, 'fcm_tokens');
    const q = query(tokensRef, where('userId', '==', userId), where('token', '==', token));
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      // Le token n'existe pas encore, l'ajouter
      await addDoc(collection(db, 'fcm_tokens'), {
        userId,
        userType, // 'admin', 'farmer', etc.
        token,
        createdAt: serverTimestamp(),
        platform: getPlatformInfo()
      });
      console.log('Token FCM enregistré avec succès');
    } else {
      console.log('Token FCM déjà enregistré pour cet utilisateur');
    }
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du token:', error);
  }
};

// Fonction pour obtenir des informations sur la plateforme
const getPlatformInfo = () => {
  const userAgent = navigator.userAgent;
  let platform = 'web';
  let os = 'unknown';
  
  if (/iPhone|iPad|iPod/.test(userAgent)) {
    os = 'iOS';
    if (window.navigator.standalone) {
      platform = 'pwa';
    } else {
      platform = 'web';
    }
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
    if (window.matchMedia('(display-mode: standalone)').matches) {
      platform = 'pwa';
    } else {
      platform = 'web';
    }
  } else if (/Windows|Mac|Linux/.test(userAgent)) {
    os = /Windows/.test(userAgent) ? 'Windows' : /Mac/.test(userAgent) ? 'MacOS' : 'Linux';
    platform = 'web';
  }
  
  return { platform, os, userAgent };
};

// Fonction pour envoyer une notification aux administrateurs
export const notifyAdmins = async (announcementId, announcementTitle, action, farmerName) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      type: 'admin_notification',
      announcementId,
      announcementTitle,
      action, // 'created' ou 'updated'
      farmerName,
      createdAt: serverTimestamp(),
      status: 'unread'
    });
    console.log(`Notification envoyée aux administrateurs pour l'annonce ${announcementId}`);
  } catch (error) {
    console.error('Erreur lors de l\'envoi de la notification:', error);
  }
};

// Fonction pour envoyer une notification à un agriculteur
export const notifyFarmer = async (farmerId, announcementId, announcementTitle, status) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      type: 'farmer_notification',
      farmerId,
      announcementId,
      announcementTitle,
      status, // 'approved' ou 'rejected'
      createdAt: serverTimestamp(),
      read: false
    });
    console.log(`Notification envoyée à l'agriculteur ${farmerId} pour l'annonce ${announcementId}`);
  } catch (error) {
    console.error('Erreur lors de l\'envoi de la notification:', error);
  }
};